import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { HttpInterceptor } from '../shared/index';
import { AppService } from '../app.service';
import { environment } from '../../environments/environment';
import { Facility } from '../facility'
import { CONSTANT_MESSAGES } from '../constants/constants-messages';
import { UtilityFunctions } from '../shared/utility-functions';

@Injectable()
export class FacilityService {
    private _appService;
    private utilityFunctions = new UtilityFunctions();
    constructor(private http: HttpInterceptor, appService: AppService) {
        this._appService = appService;

    }

    /**
     * create facility service API call
     *
     * @param {Facility} facilityObject
     * @returns
     *
     * @memberOf FacilityService
     */
    addFacility(facilityObject: Facility) {
        let url = CONSTANT_VALUES.URL_CREATE_OR_UPDATE_FACILITY;
        return new Promise((resolve, reject) => {
            this.http.post(url, facilityObject).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    /**
     * Update facility service API call
     *
     * @param {Facility} facility
     * @returns
     *
     * @memberOf FacilityService
     */
    updateFacility(facility: Facility) {
        let url = CONSTANT_VALUES.URL_CREATE_OR_UPDATE_FACILITY;
        return new Promise((resolve, reject) => {
            this.http.put(url, facility).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    /**
     * Validate whole facility object before create or update
     *
     * @param {any} facility
     * @param {any} validate
     * @param {any} unitNames
     * @param {any} closeTimeArray
     * @param {any} peekTimingsArray
     * @param {any} functionHallFlag
     * @returns
     *
     * @memberOf FacilityService
     */
    validateFacilityObject(
        facility,
        validate,
        unitNames,
        closeTimeArray,
        peekTimingsArray,
        functionHallFlag,
        bookingUnit_hour,
        bookingUnit_minute
    ) {
        validate.flag = true;

        if (!this.utilityFunctions.validateFacilityName(facility.name) || facility.name == '') {
            validate.validName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validName = '';
        }
        if (facility.noOfUnits === '') {
            validate.validNoOfUnits = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validNoOfUnits = '';
        }
        if (facility.category === '') {
            validate.category = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.category = '';
        }
        if (facility.timings.openTime === '') {
            validate.validOpenTime_hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.validOpenTime_minute = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validOpenTime_hour = '';
            validate.validOpenTime_minute = '';
        }
        if (facility.timings.closeTime === '') {
            validate.validCloseTime_hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.validCloseTime_minute = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validCloseTime_hour = '';
            validate.validCloseTime_minute = '';
        }
        if (facility.icon === '') {
            validate.validIcon = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validIcon = '';
        }
        if (facility.isChargable && facility.amount.value === '') {
            validate.validAmount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validAmount = '';
        }
        if (facility.isChargable && facility.holdBookingDays === '') {
            validate.validHoldBooking = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validHoldBooking = '';
        }
        if (facility.isAttendeeCountRequired && (facility.maxNumberOfPeopleWeekday === '' || facility.maxNumberOfPeopleWeekday == '0')) {
            validate.validMaxNumberOfPeopleWeekday = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validMaxNumberOfPeopleWeekday = '';
        }
        if (facility.isAttendeeCountRequired && (facility.maxNumberOfPeopleWeekend === '' || facility.maxNumberOfPeopleWeekday == '0')) {
            validate.validMaxNumberOfPeopleWeekend = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validMaxNumberOfPeopleWeekend = '';
        }
        // number of bookings
        if (_.indexOf(CONSTANT_VALUES.AMENITIES, facility.category) < 0) {
            if (facility.maxWeekdayBooking === '' && facility.isMaxBookingPerPerson) {
                validate.validMaxWeekdayBooking = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validate.flag = false;
            } else {
                validate.validMaxWeekdayBooking = '';
            }
            if (facility.maxWeekendBooking === '' && facility.isMaxBookingPerPerson) {
                validate.validMaxWeekendBooking = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validate.flag = false;
            } else {
                validate.validMaxWeekendBooking = '';
            }
            // booking hours
            if (facility.maxBookingHoursWeekday === '' && facility.isMaxBookingPerMembership) {
                validate.validMaxBookingHoursWeekday = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validate.flag = false;
            } else {
                validate.validMaxBookingHoursWeekday = '';
            }
            if (facility.maxBookingHoursWeekend === '' && facility.isMaxBookingPerMembership) {
                validate.validmaxBookingHoursWeekend = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validate.flag = false;
            } else {
                validate.validmaxBookingHoursWeekend = '';
            }
        }
        if (facility.isWaitlistEnabled && facility.waitlistCount === '') {
            validate.validWaitlistCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validWaitlistCount = '';
        }
        if (facility.isMaxBookingsPerSlot && facility.maxBookingsPerSlot === '') {
            validate.validmaxNumberOfPeoplePerSlot = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validmaxNumberOfPeoplePerSlot = '';
        }
        if (facility.reminder.value === '') {
            validate.validReminder = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validReminder = '';
        }
        if (facility.notificationAcceptanceHour === '') {
            validate.validNotificationAcceptanceHour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validNotificationAcceptanceHour = '';
        }
        if (facility.peakUnitsCount === '' && facility.isPeakTimeEnabled) {
            validate.validPeekSlotDuraion = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validPeekSlotDuraion = '';
        }
        if (this.utilityFunctions.validatenameString(unitNames) && unitNames) {
            validate.validUnitNames = '';
        } else {
            validate.validUnitNames = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        }
        if (closeTimeArray.length <= 0 && facility.isBreakTimeEnabled) {
            validate.validClosedTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validClosedTime = '';
        }
        if (peekTimingsArray.length <= 0 && facility.isPeakTimeEnabled) {
            validate.validPeekTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        } else {
            validate.validPeekTime = '';
        }

        if (!(_.indexOf(CONSTANT_VALUES.AMENITIES, facility.category) >= 0)) {
            if (bookingUnit_hour || bookingUnit_hour == '00') {
                validate.bookingUnit_hour = '';
            } else {
                validate.bookingUnit_hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validate.flag = false;
            }
            if (bookingUnit_minute || bookingUnit_minute == '00') {
                validate.bookingUnit_minute = '';
            } else {
                validate.bookingUnit_minute = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validate.flag = false;
            }
        } else {
            validate.bookingUnit_hour = '';
            validate.bookingUnit_minute = '';
        }
        if (facility.isGSTApplicable && facility.GSTValue) {
            validate.GSTValue = '';
        } else if (!facility.isGSTApplicable) {
            validate.GSTValue = '';
            facility.GSTValue = ''
        } else {
            validate.GSTValue = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            validate.flag = false;
        }

        return validate.flag;
    }
    /**
     * Validate time slots while facility rule setting
     *
     * @param {any} timings
     * @param {any} closeTimeArray
     * @param {any} peekTimingsArray
     * @param {any} isPeakTimeEnabled
     * @param {any} isBreakTimeEnabled
     * @param {any} slotDuration
     * @returns
     *
     * @memberOf FacilityService
     */
    validateFunctionality(timings, closeTimeArray, peekTimingsArray, isPeakTimeEnabled, isBreakTimeEnabled, bookingUnit_hour, bookingUnit_minute, category) {
        let response = {
            status: 300,
            message: ''
        };
        timings = {
            openTime: timings.openTime.replace(/:00:00/g, ''),
            closeTime: timings.closeTime.replace(/:00:00/g, '')
        };
        let errMessage = '';
        let maxSlot;
        let timeArrStart = [];
        let timeArrEnd = [];
        if (timings.openTime > timings.closeTime) {
            errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_START_TIME_AND_END_TIME;
            response.status = 301;
            response.message = errMessage;
            return response;
        } else { }
        if (timings.openTime === timings.closeTime) {
            errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_TIME_DURATION;
            response.status = 309;
            response.message = errMessage;
            return response;
        } else { }
        if (isBreakTimeEnabled) {
            for (let rec of closeTimeArray) {
                if (rec.start < timings.openTime || rec.end > timings.closeTime) {
                    response.status = 302;
                    errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_CLOSED_TIME_SLOT;
                    response.message = errMessage;
                    return response;
                }
                if (rec.start > rec.end) {
                    response.status = 303;
                    errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_CLOSED_START_TIME_AND_END_TIME;
                    response.message = errMessage;
                    return response;
                }
                if (rec.start === rec.end) {
                    response.status = 304;
                    errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_CLOSED_TIME_DURATION;
                    response.message = errMessage;
                    return response;
                }
            }
        }
        if (isPeakTimeEnabled) {
            for (let rec of peekTimingsArray) {
                if (rec.start < timings.openTime || rec.end > timings.closeTime) {
                    response.status = 305;
                    errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_PEAK_TIME_SLOT;
                    response.message = errMessage;
                    return response;
                }
                if (rec.start > rec.end) {
                    response.status = 306;
                    errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_PEAK_START_TIME_AND_END_TIME;
                    response.message = errMessage;
                    return response;
                }
                if (rec.start === rec.end) {
                    response.status = 307;
                    errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_PEAK_TIME_DURATION;
                    response.message = errMessage;
                    return response;
                }
            }
            for (let peaktime of peekTimingsArray) {
                for (let closedTime of closeTimeArray) {
                    if (peaktime.start >= closedTime.start && peaktime.end <= closedTime.end ||
                        peaktime.start <= closedTime.start && peaktime.end >= closedTime.end) {
                        response.status = 308;
                        errMessage = CONSTANT_MESSAGES.ERROR_IN_FACILITY_PEAK_TIME_AND_CLOSED_TIME;
                        response.message = errMessage;
                        return response;
                    }
                }
            }
        }
        if (_.indexOf(CONSTANT_VALUES.AMENITIES, category) < 0) {
            if (bookingUnit_hour == '00' && bookingUnit_minute == '00') {
                response.status = 308;
                errMessage = 'Please select valid booking unit';
                response.message = errMessage;
                return response;
            } else if (bookingUnit_hour && bookingUnit_minute && !this.checkBookingUnits(bookingUnit_hour, bookingUnit_minute, closeTimeArray, timings)) {
                response.status = 309;
                errMessage = 'Booking unit should within activity time';
                response.message = errMessage;
                return response;
            }
        }

        return response;
    }
    /**
     * Delete facility service API call
     *
     * @param {any} facility
     * @returns
     *
     * @memberOf FacilityService
     */
    deleteFacility(facility) {
        let url = CONSTANT_VALUES.URL_DELETE_FACILITY;
        return new Promise((resolve, reject) => {
            this.http.post(url, facility).map((res) => res.json()).subscribe(data => {
                resolve(data);
            });
        });
    }

    checkBookingUnits(bookingUnit_hour, bookingUnit_minute, closeTimeArray, timings) {
        // let slots: number[] = [];
        // let closeTimeArrayMin = [];
        // let hour, minute;
        // let _start, _end;
        let activityStart = timings.openTime.split(':');
        let activityEnd = timings.closeTime.split(':');
        let activityStartMin = parseInt(activityStart[0]) * 60 + parseInt(activityStart[1]);
        let activityEndMin = parseInt(activityEnd[0]) * 60 + parseInt(activityEnd[1]);
        let activityTime = activityEndMin > activityStartMin ? activityEndMin - activityStartMin : 0;
        let slotDuration = parseInt(bookingUnit_hour) * 60 + parseInt(bookingUnit_minute);
        return slotDuration > activityTime ? false : true;
        // if (closeTimeArray.length >= 1) {
        //     closeTimeArray.forEach(element => {
        //         _start = element.start.split(':');
        //         _end = element.end.split(':');
        //         closeTimeArrayMin.push({ startMin: parseInt(_start[0]) * 60 + parseInt(_start[1]), endMin: parseInt(_end[0]) * 60 + parseInt(_end[1]) });
        //     });

        //     slots.push(closeTimeArrayMin[0].startMin - activityStartMin);
        //     if (closeTimeArrayMin.length > 2) {
        //         for (let i = 0; i < closeTimeArrayMin.length; i++) {
        //             slots.push(closeTimeArrayMin[i + 1].startMin - closeTimeArrayMin[i].endMin);
        //         }
        //     }
        //     slots.push(activityEndMin - closeTimeArrayMin[closeTimeArrayMin.length - 1].endMin);
        // }
        // let minVal = Math.min(...slots);
        // console.log('slots', slots)
        // console.log('minVal', minVal);
    }
}



// WEBPACK FOOTER //
// ./src/app/facility/facility.service.ts